// Per-row resilience helpers for the missions gateway, extracted from
// serviceLayerGateway.ts for guard-file-size compliance (GUARD-S1 touch-it-own-it,
// 300-LOC ceiling). Pure functions — no network, no state.
import type { Mission } from '../../api/missions-types';
import { toUiMission, toUiMissionLead } from './serviceLayerGateway.mappers';

// D-33 / "0 opinion in FE": `toUiMission`/`toUiMissionLead` throw on a row that
// fails the (render-only-loosened) schema. We do NOT isolate + log + skip — a
// silently-skipped row is an invisible undercount (the "15 stops in DB → 9
// Leads" disease, same class as the mission-board 15→9 drop). Instead the
// decode error propagates: the consumer surfaces the drift loudly (error
// boundary / banner) rather than quietly rendering a shortened list. The schema
// is deliberately tolerant of varied status/state, numeric ids and odd
// order_index so a REAL row is never thrown for cosmetic reasons; if it still
// throws, a required field was genuinely undecodable — which MUST fail loud.
export function normalizeMissionArray(rows: unknown[]): Mission[] {
  return rows.map(toUiMission);
}

export function normalizeMissionLeadArray(rows: unknown[]): ReturnType<typeof toUiMissionLead>[] {
  return rows.map(toUiMissionLead);
}
